import api from "./api";

const URL_PREFIX = '/user/';

class UserService {
  getAnalysisId(customer_id = '') {
    const params = { customer_id };
    return api.get(URL_PREFIX + "getAnalysisId", { params });
  }

  getUser() {
    return api.get(URL_PREFIX + "getUser");
  }

  checkBackend() {
    return api.post(URL_PREFIX + "checkBackend");
  }

}

const userServiceInstance = new UserService();

export default userServiceInstance;